import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "list"]

  add() {
    const count = this.listTarget.querySelectorAll("[data-entry]").length
    const clone = this.templateTarget.content.cloneNode(true)

    clone.querySelectorAll("[name]").forEach((el) => {
      el.name = el.name.replace(/NEW_INDEX/g, count)
    })

    this.listTarget.appendChild(clone)
  }

  remove(event) {
    const row = event.target.closest("[data-entry]")
    if (row) row.remove()
  }
}
